module.exports = __webpack_public_path__ + "img/pt.a056d3c8.png";